module.exports = __webpack_public_path__ + "src/assets/img/4_3art_2part.ff27da0b.jpg";